import { getFormData } from "helpers/convertFormData";
import { axios } from "../middleware";

export type ReceivableUploadRowStatus = "applied" | "waiting" | "skipped" | "errored";

export type ReceivableUploadStatus = "pending" | "processing" | "completed" | "errored";

export interface ReceivableUploadRowResponse {
  row_number: number | null;
  status: ReceivableUploadRowStatus;
  invoice_number: string;
  load_number: string;
  payment_number: string;
  detail: string;
  old_status: number | null;
  new_status: number | null;
}

export interface ReceivableUploadResponse {
  id: string;
  created: string;
  filename: string;
  status: ReceivableUploadStatus;
  total_rows: number;
  applied_count: number;
  skipped_count: number;
  errored_count: number;
  row_results?: ReceivableUploadRowResponse[];
  row_results_count: number;
  row_results_truncated: boolean;
  file_url?: string;
}

interface ReceivablesHistoryParams {
  limit?: number;
  offset?: number;
}

export const getOffPlatformReceivablesUploadsAPI = async ({
  limit = 20,
  offset = 0
}: ReceivablesHistoryParams = {}) => {
  return axios.get("/payments/off_platform_receivables/", {
    params: { limit, offset }
  });
};

export const uploadOffPlatformReceivablesAPI = async (file: File) => {
  return axios.post("/payments/off_platform_receivables/", getFormData({ file }));
};

export const getOffPlatformReceivablesUploadAPI = async (uploadId: string) => {
  return axios.get<ReceivableUploadResponse>(`/payments/off_platform_receivables/${uploadId}/`);
};

export type OffPlatformReceivableStatus =
  | "off_platform_open"
  | "off_platform_paid"
  | "off_platform_settled"
  | "off_platform_short_paid"
  | "off_platform_over_paid"
  | "off_platform_write_off";

export interface OffPlatformReceivableResponse {
  id: string;
  invoice_number: string | null;
  load_number: string | null;
  debtor_name: string | null;
  carrier_name: string | null;
  amount: number;
  amount_paid: number | null;
  amount_balance: number | null;
  status: OffPlatformReceivableStatus;
  aging: number;
  paid_date: string | null;
  created: string;
}

export interface OffPlatformReceivablesListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: OffPlatformReceivableResponse[];
  status_counts: Partial<Record<OffPlatformReceivableStatus, number>>;
}

interface ReceivablesListParams {
  limit?: number;
  offset?: number;
  search?: string;
  status?: string;
}

export const getOffPlatformReceivablesListAPI = async ({
  limit = 20,
  offset = 0,
  search,
  status
}: ReceivablesListParams = {}) => {
  return axios.get<OffPlatformReceivablesListResponse>("/payments/off_platform_receivables/list/", {
    params: { limit, offset, ...(search && { search }), ...(status && { status }) }
  });
};
